import React, { useEffect, useState } from "react";
import { Edit, SimpleForm, TextInput, useEditContext, useNotify } from "react-admin";

// Components
import EditToolbar from "../EditToolbar";
import ResetPasswordButton from "../Users/ResetPasswordButton";
import ChangeMyPasswordButton from "./ChangeMyPasswordButton";

// Providers
import { adminsProvider } from "../../providers/admins";

// Hooks
import useValidators from "../../hooks/useValidators";

type Admin = { id: string; email: string; name: string };

const Aside: React.FC = () => {
  const { record: data } = useEditContext<Admin>();
  const { text } = useValidators();
  const [currentAdminId, setCurrentAdminId] = useState<string | null>(null);

  useEffect(() => {
    adminsProvider.getIdentity().then((identity) => setCurrentAdminId(identity?.id ?? null));
  }, []);

  return (
    <>
      {data && (
        <div style={{ display: "flex", justifyContent: "flex-end", padding: "1em 1em 0" }}>
          {currentAdminId === data.id ? (
            <ChangeMyPasswordButton />
          ) : (
            <ResetPasswordButton
              userId={data.id}
              dialogTitle="Reset admin password"
              onReset={adminsProvider.resetPassword}
            />
          )}
        </div>
      )}
      <SimpleForm mode="onBlur" reValidateMode="onBlur" toolbar={<EditToolbar name="admin" resource="admins" />}>
        <TextInput disabled label="Id" source="id" />
        <TextInput disabled label="Email" source="email" />
        <TextInput label="Name" source="name" validate={text} />
      </SimpleForm>
    </>
  );
};

export const EditComponent: React.FC = () => {
  const notify = useNotify();

  const onSuccess = () => {
    notify(`Admins updated successfully`, { type: "success" });
  };

  const onError = (error: any) => {
    notify(error.message, { type: "error" });
  };

  return (
    <Edit mutationMode="pessimistic" mutationOptions={{ onSuccess, onError }}>
      <Aside />
    </Edit>
  );
};
